<template>
  <Layout>
    <template #title>
      This athlete hasn’t added athletic information yet
    </template>
  </Layout>
</template>

<script>
import Layout from '../../EmptyStateLayout.vue'

export default {
  components: { Layout },
}
</script>